import { calculatePreciseValue } from '../SliderFormat';
/**
 * @param start - start value
 * @param end - end value
 * @param numberOfTicks - number of tick marks
 * @param step - The value change for a step
 * @returns an array of numbers representing the Slider tick positions
 */
const createSliderTicks = (start, end, numberOfTicks, step) => {
  const result = [];
  if (numberOfTicks < 1) return result;
  const delta = (end - start) / (numberOfTicks - 1);
  while (start < end) {
    result.push(calculatePreciseValue(start, step));
    start += delta;
  }
  if (result[result.length - 1] !== end) {
    result.push(end);
  }
  return result;
};

/**
 * @param scale - provides the min and max slider values
 * @param ticks - an array of tick values or a number to create an array of tick values
 * @param tickLabelsLength - number of custom ticks
 * @param step - The value change for a step
 * @returns an array of numbers representing the Slider ticks
 */
export const getSliderTicks = (scale, ticks, tickLabelsLength, step) => {
  if (Array.isArray(ticks) && ticks.length) return ticks;
  const numberOfTicks = typeof ticks === 'number' && !isNaN(ticks) ? ticks : tickLabelsLength ?? 0;
  return createSliderTicks(scale.minValue, scale.maxValue, numberOfTicks, step);
};
export const calculateSliderStep = (size, step, scale) => {
  const smallStep = typeof step === 'number' ? step : 1;
  const range = scale.maxValue - scale.minValue;
  const calculatedStep = size === 'medium' ? Math.max(smallStep, range / 50) : Math.max(smallStep, range / 10);
  return calculatedStep;
};
//# sourceMappingURL=utils.js.map